export default __webpack_public_path__ + "static/media/fridge1-after2-768w.b8d87ad9.png";